import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22mono.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/geist-mono/GeistMono-Variable.woff2%22,%22variable%22:%22--font-geist-mono%22,%22adjustFontFallback%22:false,%22fallback%22:[%22ui-monospace%22,%22SFMono-Regular%22,%22Roboto%20Mono%22,%22Menlo%22,%22Monaco%22,%22Liberation%20Mono%22,%22DejaVu%20Sans%20Mono%22,%22Courier%20New%22,%22monospace%22],%22weight%22:%22100%20900%22}],%22variableName%22:%22GeistMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'GeistMono', ui-monospace, SFMono-Regular, Roboto Mono, Menlo, Monaco, Liberation Mono, DejaVu Sans Mono, Courier New, monospace",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
